import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  type?: 'website' | 'article' | 'product';
  image?: string;
  imageAlt?: string;
  keywords?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  noindex?: boolean;
}

const SEOHead = ({
  title,
  description,
  canonical,
  type = 'website',
  image = 'https://storage.googleapis.com/gpt-engineer-file-uploads/uHbIG9nnaBZQjY4WsFxRjs1X8Ry2/social-images/social-1766698711409-Fav MaterialiDtf.png',
  imageAlt = 'Materialidtf.it - Materiali per Stampa DTF',
  keywords,
  author = 'Materialidtf.it',
  publishedTime,
  modifiedTime,
  noindex = false,
}: SEOHeadProps) => {
  const siteUrl = 'https://materialidtf.it';
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : undefined;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Canonical URL */}
      {fullCanonical && <link rel="canonical" href={fullCanonical} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:site_name" content="Materialidtf.it" />
      <meta property="og:locale" content="it_IT" />
      {fullCanonical && <meta property="og:url" content={fullCanonical} />}
      
      {/* Article specific */}
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Materialidtf" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt} />
      
      {/* Additional SEO */}
      <meta name="format-detection" content="telephone=no" />
      <meta name="theme-color" content="#d91a5b" />
      <meta httpEquiv="content-language" content="it" />
    </Helmet>
  );
};

export default SEOHead;
